import { ReactElement } from 'react';
export enum FilterTypes {
  CONST = 'const',
  RANGE = 'range',
  DATE = 'date',
  DATE_RANGE = 'date_range',
  TEXT = 'text',
  ALLOCATION = 'allocation',
  WEEKDAY = 'weekday',
  AUTOCOMPLETE = 'autocomplete',
  TAGS = 'tags'
}

export enum FilterOps {
  EQ = 'eq',
  NEQ = 'neq',
  LTE = 'lte',
  GTE = 'gte',
  GT = 'gt',
  LT = 'lt',
  DOES = 'eq',
  CONTAINS = 'contains'
}

export type TFilterValueObject = {
  eq?: Object | string | number;
  neq?: string | number;
  gt?: number;
  lt?: number;
  gte?: number | string;
  lte?: number | string;
  contains?: string;
};
export type TOptionConfig = TOptionConfigSubOption & {
  buildColumn?: Function; // creates a react-table compatible column for this field
  allowedOperators?: FilterOps[];
  columnPlacement?: 'default' | 'right';
  defaultValue?: TFilterValueObject;
  labelParts?: number; // Number of bullet-separated segments to show in chip label (default: 1)
  inputParser?: (val: string, missingValue: any) => any;
  inputStep?: number | 'any';
  relatedColumns?: string[];
};

export type TOptionConfigDictionary = {
  [key: string]: TOptionConfig;
};

export type TOptionsConfig = {
  [key: string]: TOptionConfigDictionary;
};

export type TOptionConfigSubOption = {
  id?: string | number;
  displayName?: ReactElement | string;
  filterPath?: string;
  filterType?: FilterTypes;

  iconUrl?: string;
  customClass?: string;
  options?: TOptionConfigSubOption[];
  label?: string;
  value?: string;
  align?: string;
  disable?: boolean; // FIXME: is this actually used?
};

export type TSearchFilterOption = {
  displayName: ReactElement | string;
  filterPath?: string;
  options?: TOptionConfig[];
};

export type TMemberType = {
  displayName: string;
  singularName: string;
  filterPath: string;
};

export type TSearchFilters = {
  character: TSearchFilterOption[];
  guild: TSearchFilterOption[];
  team: TSearchFilterOption[];
  mythic_plus_runs: TSearchFilterOption[];
  raid_encounters: TSearchFilterOption[];
  [key: string]: TSearchFilterOption[];
};

export enum SearchFiltersType {
  Character = 'character',
  Guild = 'guild',
  Team = 'team',
  MythicPlusRuns = 'mythic_plus_runs',
  RaidEncounters = 'raid_encounters'
}
